// removed by extract-text-webpack-plugin
module.exports = {"borderGray":"#d9d9d9","title":"title-25rsO title-3Pxrp","dumbbell":"dumbbell-2n_AK dumbbell-2TGi2","description":"description-P55ba description-2Cux_","workoutForm":"workoutForm-3jVr6 workoutForm-RrQ_u","loadingModal":"loadingModal-2NFKm loadingModal-3jdpd","loadingTitle":"loadingTitle-3880d loadingTitle-2zcjn","pageLoader":"pageLoader-3KEu-","error":"error-mbUoW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/copy/_copyWorkoutPage.css
// module id = 1285
// module chunks = 1